import React from "react";

const Establish = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
      <rect
        x="1"
        y="2"
        width="10"
        height="9"
        rx="1"
        stroke="var(--tx2)"
        strokeWidth="1"
      />
      <line x1="4" y1="1" x2="4" y2="3" stroke="var(--tx2)" strokeWidth="1" />
      <line x1="8" y1="1" x2="8" y2="3" stroke="var(--tx2)" strokeWidth="1" />
    </svg>
  );
};

export default Establish;
